import type { Updater } from '@tanstack/vue-table'
import type { RoutesNamesList, NuxtRoute } from '@typed-router'
import type { Ref } from 'vue'
import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import type {
  DateValue,
} from '@internationalized/date'
import { toDate } from 'reka-ui/date'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function valueUpdater<T extends Updater<any>>(updaterOrValue: T, ref: Ref) {
  ref.value
    = typeof updaterOrValue === 'function'
      ? updaterOrValue(ref.value)
      : updaterOrValue
}

export function calendarDateToString(date?: DateValue): string | undefined {
  if (!date) return undefined

  try {
    const jsDate = toDate(date)
    // Use a timezone-neutral approach instead of toISOString()
    const year = jsDate.getFullYear()
    const month = String(jsDate.getMonth() + 1).padStart(2, '0')
    const day = String(jsDate.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}` // YYYY-MM-DD format
  }
  catch (e) {
    console.error('Error converting CalendarDate to string:', e)
    return undefined
  }
}

export function isActive<T extends RoutesNamesList, P extends string>(path: NuxtRoute<T, P>) {
  const route = useRoute()
  return route.path.toString() === path.toString()
}

export function hasActiveChild<T extends RoutesNamesList, P extends string>(path: NuxtRoute<T, P>) {
  const route = useRoute()
  return route.path.toString().startsWith(path.toString())
}
